// extracted by mini-css-extract-plugin
export default {"open-box":"CalloutBoxSelector-module__open-box__YVWok","box":"CalloutBoxSelector-module__box__p4z83","callout":"CalloutBoxSelector-module__callout__GW50Y"};